<script>
  import { M } from '../../../external';
  import { ignore } from '../../../Common/tools';
  import { onMount } from 'svelte';
  import DiscussionService from '../service';
  import ImagePicker from '../../../Common/ImagePicker.svelte';
  import ColorPicker from '../../../Common/ColorPicker.svelte';
  import DropdownInputWithSearchAndAdd from '../../Common/DropdownInputWithSearchAndAdd.svelte';
  export let wall,
    onChange = ignore,
    refreshUI = ignore,
    showGroupStyleSettings;

  const existingWalls = {
    isLoading: false,
    data: []
  };

  const roleOptions = [
    { value: 0, name: M.ONLY_ADMINS },
    { value: 1, name: M.ADMINS_MODERATORS },
    { value: 2, name: M.ALL_MEMBERS }
  ];

  let selectedContext = {
    resourceId: '',
    name: '',
    moderation: { writePermission: 0, approvalRequired: 0 },
    extra: {
      allowMentions: true,
      allowImages: true,
      notifyOnReply: 'ONLY_FIRST_DEPTH'
    }
  };

  const onContextChanged = (selected) => {
    wall.resourceId = selected.resourceId;
    wall.groupSettings.name = selected.name;
    selectedContext = selected;
    onChange();
    refreshUI();
    checkIfContextIsOutdated();
  };

  const onContextUpdated = (partialUpdate) => {
    DiscussionService.partialUpdateContext('discussion', wall.resourceId, partialUpdate);
  };

  const checkIfContextIsOutdated = () => {
    if (!selectedContext.extra.notifyOnReply) {
      if (confirm("Context out-of-date. 'notifyOnReply' is not set. Do you want me to upgrade?")) {
        onContextUpdated({ extra: { notifyOnReply: 'ONLY_FIRST_DEPTH' } });
        selectedContext.extra.notifyOnReply = 'ONLY_FIRST_DEPTH';
      }
    }
  };

  onMount(async () => {
    existingWalls.isLoading = true;
    existingWalls.data = await DiscussionService.getContexts();
    selectedContext = existingWalls.data.find((context) => context.resourceId === wall.resourceId) || {
      resourceId: '',
      name: '',
      moderation: { writePermission: 0, approvalRequired: 0 },
      extra: {
        allowMentions: true,
        allowImages: true,
        notifyOnReply: 'ONLY_FIRST_DEPTH'
      }
    };
    existingWalls.isLoading = false;

    checkIfContextIsOutdated();
  });
</script>

<div class="input-wrapper">
  <div class="info" style="width: 100%; margin-top: 5px">
    <h5>{M.ENTER_CHANNEL_NAME}</h5>
  </div>
  {#if !existingWalls.isLoading}
    <div class="col20 f-left">
      <DropdownInputWithSearchAndAdd
        service={DiscussionService}
        inputValue={selectedContext.name}
        onChange={onContextChanged}
        options={existingWalls.data} />
    </div>
  {/if}
</div>

<div class="popup-input-wrapper mb-0 mt-10">
  <div class="info">
    <h5>{M.SOCIAL_WHO_CAN_MESSAGE}</h5>
  </div>
  <select
    class="col20 f-left"
    bind:value={selectedContext.moderation.writePermission}
    on:change={() => {
      onContextUpdated({ moderation: { writePermission: selectedContext.moderation.writePermission } });
    }}>
    {#each roleOptions as option}
      <option value={option.value}>{option.name}</option>
    {/each}
  </select>
</div>

{#if showGroupStyleSettings}
  <h4 class="col20 f-left mt-15 mb-15 t-left"><b>{M.HEADER_STYLE}</b></h4>
  <div class="popup-input-wrapper">
    <h5>{M.GROUP_IMAGE}</h5>
    <span class="col20 f-left small-info-text mt-5"
      >{M.GROUP_IMAGE_DESC}</span>
    <ImagePicker
      onChange={() => {
        onChange();
        refreshUI();
      }}
      bind:image={wall.groupSettings.icon.image}
      bind:imageBase={wall.groupSettings.icon.imageBase} />
  </div>
  <div class="popup-input-wrapper">
    <h5>{M.GROUP_DESC}</h5>
    <input
      type="text"
      bind:value={wall.groupSettings.description}
      on:blur={() => {
        onChange();
        refreshUI();
      }} />
  </div>
  <div class="popup-input-wrapper mb-0">
    <div class="checkbox-wrapper">
      <input
        id="useColorAsBg"
        bind:checked={wall.groupSettings.useColorAsBg}
        on:change={() => {
          onChange();
          refreshUI();
        }}
        class="css-checkbox"
        type="checkbox"
        name="useColorAsBg" />
      <label for="useColorAsBg" class="css-label button-tooltip" data-original-title="" title=""
        >{M.SHOW_GROUP_BG}</label>
    </div>
  </div>
  <div class="input-wrapper col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={wall.groupSettings.color}
      label={M.GROUP_COLOR}
      onChange={() => {
        onChange();
        refreshUI();
      }} />
  </div>
{/if}
